import { render } from "./addBookmark.vue?vue&type=template&id=f100c6a4"
import script from "./addBookmark.vue?vue&type=script&lang=js"
export * from "./addBookmark.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__